/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MenInputs */

const en_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Men`)
};

const es_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hombres`)
};

const fr_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hommes`)
};

const de_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herren`)
};

const ja_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンズ`)
};

const zh_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`男装`)
};

const ar_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجالي`)
};

const id_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pria`)
};

const it_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uomo`)
};

const ru_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мужчинам`)
};

const pt_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masculino`)
};

const ko_val_men = /** @type {(inputs: Val_MenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`남성용`)
};

/**
* | output |
* | --- |
* | "Men" |
*
* @param {Val_MenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_men = /** @type {((inputs?: Val_MenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_men(inputs)
	if (locale === "es") return es_val_men(inputs)
	if (locale === "fr") return fr_val_men(inputs)
	if (locale === "de") return de_val_men(inputs)
	if (locale === "ja") return ja_val_men(inputs)
	if (locale === "zh") return zh_val_men(inputs)
	if (locale === "ar") return ar_val_men(inputs)
	if (locale === "id") return id_val_men(inputs)
	if (locale === "it") return it_val_men(inputs)
	if (locale === "ru") return ru_val_men(inputs)
	if (locale === "pt") return pt_val_men(inputs)
	return ko_val_men(inputs)
});